/* KAKISHIBU – carrito en panel lateral: abrir, cantidades, envío seguro, regalo automático y barra de progreso. */
(function () {
  'use strict';
  if (window.__kkCart) return; window.__kkCart = 1;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = function () { return document.getElementById('kk-cart'); };
  var HID_GIFT = 'regalo-jabonera-de-bambu', HID_INS = 'envio-seguro';

  /* ---------- moneda: umbrales en euros convertidos a la moneda de quien compra ---------- */
  function rate() { if (cur() === 'USD') return 1; var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; } /* en USD los precios son los mismos números que en € */
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; }
  function fmt(cents) {
    var c = cur(), loc = c === 'MXN' ? 'es-MX' : (document.documentElement.lang || 'es'), d = c === 'MXN' ? 0 : 2;
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: c, minimumFractionDigits: d, maximumFractionDigits: d }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(d) + ' ' + c; }
  }
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- abrir / cerrar ---------- */
  function open() {
    var r = root(); if (!r) return;
    r.classList.add('is-open'); $('.kkc__panel', r).setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('kk-lock');
  }
  function close() {
    var r = root(); if (!r) return;
    r.classList.remove('is-open'); $('.kkc__panel', r).setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('kk-lock');
  }

  /* ---------- barra de progreso + fechas ---------- */
  function businessDay(n) {
    var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
    return d.toLocaleDateString(document.documentElement.lang || 'es', { day: 'numeric', month: 'short' });
  }
  function paint() {
    var r = root(); if (!r) return;
    var base = parseFloat(r.getAttribute('data-base')) || 0, rt = rate();
    var free = (parseFloat(r.getAttribute('data-free')) || 50) * 100 * rt, gift = (parseFloat(r.getAttribute('data-gift')) || 59) * 100 * rt;
    var s1 = $('[data-seg1]', r), s2 = $('[data-seg2]', r), msg = $('[data-msg]', r);
    if (msg && s1 && s2) {
      var p1 = Math.min(1, base / free), p2 = base >= free ? Math.min(1, (base - free) / Math.max(1, gift - free)) : 0;
      s1.style.setProperty('--p', (p1 * 100) + '%'); s2.style.setProperty('--p', (p2 * 100) + '%');
      var tpl, miss;
      if (base < free) { tpl = r.getAttribute('data-m-free'); miss = free - base; }
      else if (base < gift) { tpl = r.getAttribute('data-m-gift'); miss = gift - base; }
      else { tpl = r.getAttribute('data-m-all'); miss = 0; }
      msg.innerHTML = esc(tpl || '').replace('{amount}', '<b>' + esc(fmt(Math.ceil(miss / 100) * 100)) + '</b>');
    }
    var dl = $('.kkc__deliv', r);
    if (dl) {
      var a = parseInt(dl.getAttribute('data-min'), 10) || 0, b = parseInt(dl.getAttribute('data-max'), 10) || 0;
      var f1 = $('.js-f1', dl), f2 = $('.js-f2', dl);
      if (f1) f1.textContent = businessDay(a); if (f2) f2.textContent = businessDay(Math.max(a, b));
    }
  }

  /* ---------- llamadas a la tienda ---------- */
  function jfetch(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  var change = function (key, q) { return jfetch('/cart/change.js', { id: key, quantity: q }).then(function (r) { return r.json(); }); };
  var add = function (id, q, props) { return jfetch('/cart/add.js', { items: [{ id: id, quantity: q, properties: props || {} }] }); };

  function insOff(v) {
    try { if (v === undefined) return localStorage.getItem('kk_ins_off') === '1'; if (v) localStorage.setItem('kk_ins_off', '1'); else localStorage.removeItem('kk_ins_off'); } catch (e) {}
    return false;
  }

  /* regalo automático según el importe + limpieza si no queda nada */
  function sync() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var r = root(); if (!r) return;
      var giftId = parseInt(r.getAttribute('data-gift-id'), 10), thr = (parseFloat(r.getAttribute('data-gift')) || 59) * 100 * rate();
      var base = 0, real = 0, giftItem = null, insItem = null;
      cart.items.forEach(function (it) {
        if (it.handle === HID_GIFT) giftItem = it; else if (it.handle === HID_INS) insItem = it;
        else { base += it.final_line_price; real += it.quantity; }
      });
      var jobs = [];
      var insId = parseInt(r.getAttribute('data-ins-id'), 10);
      if (real === 0) { if (giftItem) jobs.push(change(giftItem.key, 0)); if (insItem) jobs.push(change(insItem.key, 0)); insOff(false); }
      else {
        /* envío seguro preseleccionado, salvo que la clienta lo haya quitado */
        if (!insItem && insId && !insOff()) jobs.push(add(insId, 1, {}));
        if (base >= thr && !giftItem && giftId) jobs.push(add(giftId, 1, { '_regalo': 'si' }));
        if (base < thr && giftItem) jobs.push(change(giftItem.key, 0));
      }
      return Promise.all(jobs);
    });
  }

  /* contador del icono de la cabecera */
  function updateCount() {
    var r = root(), n = r ? parseInt(r.getAttribute('data-count'), 10) || 0 : 0;
    $$('.hdr__cart').forEach(function (a) {
      var b = $('.hdr__count', a);
      if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'hdr__count'; a.appendChild(b); } b.textContent = n; }
      else if (b) b.remove();
    });
  }

  /* volver a pintar el panel con lo que hay en el carrito */
  function render() {
    return fetch('/?sections=kk-cart-drawer&_=' + Date.now()).then(function (r) { return r.json(); }).then(function (j) {
      var html = j['kk-cart-drawer'], r = root(); if (!html || !r) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var nr = $('#kk-cart', tmp); if (!nr) return;
      Array.prototype.forEach.call(nr.attributes, function (a) { if (a.name !== 'class' && a.name !== 'id') r.setAttribute(a.name, a.value); });
      $('.kkc__panel', r).innerHTML = $('.kkc__panel', nr).innerHTML;
      paint(); updateCount();
    });
  }

  function refresh(openAfter) {
    var r = root(); if (!r) return Promise.resolve();
    r.classList.add('is-busy');
    return sync().catch(function () {}).then(render).catch(function () {}).then(function () {
      r.classList.remove('is-busy'); if (openAfter) open();
    });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-kk-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-qty]');
    if (q) { e.preventDefault(); var r = root(); r.classList.add('is-busy'); change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)).then(function () { return refresh(false); }); return; }
    var hc = t.closest('a.hdr__cart');
    if (hc && root()) { e.preventDefault(); refresh(true); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-ins]')) return;
    var r = root(), insId = parseInt(r.getAttribute('data-ins-id'), 10); r.classList.add('is-busy');
    if (t.checked) { insOff(false); add(insId, 1, {}).then(function () { return refresh(false); }); }
    else {
      insOff(true);
      fetch('/cart.js').then(function (x) { return x.json(); }).then(function (cart) {
        var it = cart.items.filter(function (i) { return i.handle === HID_INS; })[0];
        return it ? change(it.key, 0) : null;
      }).then(function () { return refresh(false); });
    }
  });

  /* "Agregar al carrito" sin salir de la página */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('kk-form') || !window.fetch || !root()) return;
    e.preventDefault();
    var btn = $('.atc', f); if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return refresh(true); })
      .then(function () { if (btn) btn.disabled = false; })
      .catch(function () { f.submit(); });
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('shopify:section:load', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();
